import React, { useEffect, useState, useRef } from "react";
import { useStyles } from "../AssetNonTitled/AssetNonTitledFormStyles";
import {
    Grid,
    Checkbox,
    FormControlLabel,
    TextField
} from "@material-ui/core";

export default function OriginalAssetDetails({ asset }) {

    const classes = useStyles();

    return (
        <Grid item xs={12}>
            <Grid item xs={12} align="left">
                <FormControlLabel
                    disabled={true}
                    className={classes.verticalGap}
                    checked={asset?.is_placeholder || false}
                    control={<Checkbox color="primary" name="placeholder" />}
                    label="Placeholder Asset"
                />
            </Grid>
            <Grid item xs={12} align="left">
                <TextField
                    id="vin"
                    label="VIN"
                    value={asset.vin || "No VIN"}
                    type="text"
                    margin="normal"
                    disabled
                />
            </Grid>
            <Grid item xs={12} align="left">
                <TextField
                    id="year"
                    label="Year"
                    value={asset.year || "No Year"}
                    type="text"
                    margin="normal"
                    disabled
                />
            </Grid>
            <Grid item xs={12} align="left">
                <TextField
                    id="category"
                    label="Category"
                    value={asset.pd_category || "No Category"}
                    type="text"
                    margin="normal"
                    disabled
                />
            </Grid>
            <Grid item xs={12} align="left">
                <TextField
                    id="make"
                    label="Make"
                    value={asset.make || "No Make"}
                    type="text"
                    margin="normal"
                    disabled
                />
            </Grid>
            <Grid item xs={12} align="left">
                <TextField
                    id="model"
                    label="Model"
                    value={asset.model || "No Model"}
                    type="text"
                    margin="normal"
                    disabled
                />
            </Grid>
            <Grid item xs={12} align="left">
                <TextField
                    id="config"
                    label="Description"
                    value={asset.description || "No Description"}
                    type="text"
                    margin="normal"
                    disabled
                />
            </Grid>
            <Grid item xs={12} align="left">
                <TextField
                    id="condition"
                    label="Condition"
                    value={asset.condition || "No Condition"}
                    type="text"
                    margin="normal"
                    disabled
                />
            </Grid>
            {
                asset?.type.includes("Truck") &&
                <Grid item xs={12} align="left">
                    <TextField
                        id="mileage"
                        label="Mileage"
                        value={asset?.mileage || "No Mileage"}
                        type="text"
                        margin="normal"
                        disabled
                    />
                </Grid>
            }
            {
                asset?.type.includes("Trailer") &&
                <Grid item xs={12} align="left">
                    <TextField
                        id="hours"
                        label="Usage Hours"
                        value={asset?.hours || "No Usage Hours"}
                        type="text"
                        margin="normal"
                        disabled
                    />
                </Grid>
            }
        </Grid>
    )
}
